import { DroneType } from '../../shared/types.js';

export interface DroneSpriteVisual {
  url: string;
  width: number;
  height: number;
  yOffset?: number;
  tintStrength?: number;
}

export const DRONE_SPRITE_VISUALS: Record<DroneType, DroneSpriteVisual> = {
  [DroneType.Striker]: {
    url: new URL('../assets/drones/striker.png', import.meta.url).href,
    width: 7.8,
    height: 6.8,
    yOffset: 0.15,
    tintStrength: 0.24,
  },
  [DroneType.Sniper]: {
    url: new URL('../assets/drones/sniper.png', import.meta.url).href,
    width: 5.5,
    height: 8.4,
    yOffset: 0.15,
    tintStrength: 0.2,
  },
  [DroneType.Healer]: {
    url: new URL('../assets/drones/healer.png', import.meta.url).href,
    width: 7.0,
    height: 7.0,
    yOffset: 0.2,
    tintStrength: 0.18,
  },
  [DroneType.Interceptor]: {
    url: new URL('../assets/drones/interceptor.png', import.meta.url).href,
    width: 7.4,
    height: 7.8,
    yOffset: 0.12,
    tintStrength: 0.22,
  },
  [DroneType.Support]: {
    url: new URL('../assets/drones/support.png', import.meta.url).href,
    width: 7.2,
    height: 6.8,
    yOffset: 0.18,
    tintStrength: 0.18,
  },
  [DroneType.Guardian]: {
    url: new URL('../assets/drones/guardian.png', import.meta.url).href,
    width: 7.6,
    height: 6.7,
    yOffset: 0.18,
    tintStrength: 0.16,
  },
};

export function getDroneSpriteVisual(droneType: number): DroneSpriteVisual {
  return DRONE_SPRITE_VISUALS[droneType as DroneType] ?? DRONE_SPRITE_VISUALS[DroneType.Striker];
}
